import { rootApi } from '../rootApi';

export const creditCardPaymentApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        // Taksit seçeneklerini getir
        getInstallmentOptions: builder.query({
            query: (params) => ({
                url: 'v1/creditcard/get-installments',
                method: 'POST',
                body: params
            }),
            transformResponse: (response) => ({
                success: response.isSuccessful,
                installments: response.data?.installments || [],
                virtualPosId: response.data?.virtualPosId,
                cardBin: response.data?.cardBin,
                bankName: response.data?.bankName,
                bankCode: response.data?.bankCode,
                cardType: response.data?.cardType
            }),
            providesTags: ['CreditCardPayment']
        }),

        // Ödeme işlemini gerçekleştir
        processPayment: builder.mutation({
            query: (paymentData) => ({
                url: 'v1/creditcard/process-payment',
                method: 'POST',
                body: paymentData
            }),
            transformResponse: (response) => ({
                success: response.isSuccessful,
                isSuccess: response.data?.isSuccess,
                transactionId: response.data?.transactionId,
                transactionStatusId: response.data?.transactionStatusId,
                threeDUrl: response.data?.threeDUrl,
                referenceCode: response.data?.referenceCode,
                authCode: response.data?.authCode,
                transactionInfo: response.data?.transactionInfo,
                errorMessage: response.errorMessage
            }),
            invalidatesTags: ['CreditCardPayment']
        }),

        // 3D Secure sonrası ödeme tamamlama
        commitPayment: builder.mutation({
            query: (data) => ({
                url: 'v1/creditcard/commit-payment',
                method: 'POST',
                body: data
            }),
            transformResponse: (response) => ({
                success: response.isSuccessful,
                isSuccessful: response.data?.isSuccessful ?? response.isSuccessful,
                transactionId: response.data?.transactionId,
                referenceCode: response.data?.referenceCode,
                authCode: response.data?.authCode,
                amount: response.data?.amount,
                errorMessage: response.errorMessage || response.data?.errorMessage
            }),
            invalidatesTags: ['CreditCardPayment']
        }),

        // Kart BIN sorgulama (Kart tipini belirlemek için)
        validateCardBin: builder.query({
            // Backend hazır olduğunda bu endpoint kullanılacak
            // query: (bin) => ({
            //     url: `v1/credit-card/validate-bin/${bin}`,
            //     method: 'GET'
            // }),

            // Dummy data - Backend hazır olana kadar
            queryFn: async (bin) => {
                await new Promise((resolve) => setTimeout(resolve, 300));

                if (!bin || bin.length < 6) {
                    return {
                        data: {
                            valid: false,
                            cardType: null,
                            bankName: null
                        }
                    };
                }

                // Basit kart tipi tespiti (ilk hanelere göre)
                let cardType = 'Unknown';
                let bankName = 'Bilinmeyen Banka';

                if (bin.startsWith('4')) {
                    cardType = 'Visa';
                } else if (bin.startsWith('5')) {
                    cardType = 'MasterCard';
                } else { 
                    cardType = 'Troy';
                }

                return {
                    data: {
                        valid: true,
                        cardType,
                        bankName,
                        bin
                    }
                };
            }
        }),

        // Ödeme raporları listesi
        getPaymentReports: builder.query({
            query: (params) => ({
                url: 'v1/creditcard/report',
                method: 'GET',
                params
            }),
            transformResponse: (response) => ({
                success: response.isSuccessful,
                data: response.data?.rows || [],
                totalCount: response.data?.totalCount || 0,
                pageItemCount: response.data?.pageItemCount || 0
            }),
            providesTags: ['CreditCardPayment']
        }),

        // Makbuz verisi getir
        getPaymentReceipt: builder.query({
            query: (transactionId) => ({
                url: `v1/creditcard/receipt/${transactionId}`,
                method: 'GET'
            }),
            transformResponse: (response) => ({
                success: response.isSuccessful,
                data: response.data
            })
        }),

        // Ödeme raporları Excel export
        exportPaymentReports: builder.query({
            query: ({ startDate, endDate, searchText, sortField, sortOrder, compressionType } = {}) => {
                const params = new URLSearchParams();
                if (startDate) params.append('StartDate', startDate);
                if (endDate) params.append('EndDate', endDate);
                if (searchText) params.append('SearchText', searchText);
                if (sortField) params.append('SortField', sortField);
                if (sortOrder) params.append('SortOrder', sortOrder);
                if (compressionType != null) params.append('CompressionType', compressionType);
                return { url: `v1/creditcard/report-export?${params.toString()}`, method: 'GET' };
            },
            transformResponse: (response) => {
                const data = response?.data ?? {};
                return {
                    fileBase64: data.fileBase64,
                    fileName: data.fileName,
                    contentType: data.contentType,
                    recordCount: data.recordCount,
                    fileSize: data.fileSize,
                    isCompressed: data.isCompressed,
                    compressionType: data.compressionType
                };
            }
        })
    })
});

export const { 
    useGetInstallmentOptionsQuery, 
    useLazyGetInstallmentOptionsQuery, 
    useProcessPaymentMutation, 
    useCommitPaymentMutation,
    useValidateCardBinQuery, 
    useLazyValidateCardBinQuery,
    useGetPaymentReportsQuery,
    useLazyGetPaymentReportsQuery,
    useGetPaymentReceiptQuery,
    useLazyGetPaymentReceiptQuery,
    useLazyExportPaymentReportsQuery
} = creditCardPaymentApi;

